<template>
  <section class="home_container">
    <nav class="lettersNav">
      <ul class="lettersList">
        <li :class='{select:index === cityIndex}' v-for="(item,index) in sortLetter" :key="index"
            @click="chooseLetter(index)">
          <i class="iconfont icon-location" v-if="index==0"></i>
          <i class="iconfont icon-remen" v-else-if="index==1"></i>
          <i v-else>{{item}}</i>
        </li>
      </ul>
    </nav>

    <div id="amapContainer" v-show="false"></div>
    <section class="letter_container">
      <section class="menu_container">
        <section class="menu_center" ref="menuCityList">
          <div class="content">
            <!-- <header class="home_detail_header" v-if="defaultCity.city">
              <section class="description_header">
                <section class="wrap_description">
                  <section class="description_content">
                    <div class="city_tip">
                      <p>当前位置</p>
                    </div>
                    <div class="current" @click="setCity(defaultCity)">
                      <p>{{defaultCity.city}}</p>
                    </div>
                  </section>
                </section>
              </section>
            </header> -->
            <!-- <section class="hot">
              <h4 class="city_title">热门城市</h4>
              <ul class="citylist">
                <li v-for="(item,index) in hotCityList" :key="index" @click="setCity(item)">
                  {{item.city}}
                </li>
              </ul>
            </section> -->
            <div v-for="(value, key, index) in sortGroupCity" :key="key" class="letter_classify_li">
              <h4 class="city_title">{{key}}
                <span v-if="index == 0">（按字母排序）</span>
              </h4>
              <ul class="groupcity_name_container citylistul">
                <li v-for="(item,index) in value" :key="index" class="ellipsis" @click="setCity(item)">
                  {{item.city}}
                </li>
              </ul>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
  import {mapState, mapMutations, mapGetters, mapActions} from "vuex";
  import {getShopCitys} from "@/utils/api";
  import BScroll from "better-scroll";
  import {Geo} from "@/mixin/methods";

  export default {
    name: "cityList",
    mixins: [Geo],
    data() {
      return {
        carInfo: {},
        // hotCityList: [],
        allCityList: [],
        cityListTop: [],
        cityScroll: null,
        cityIndex: 0,
        cityIndexChange: true
      };
    },
    created() {
      this.carInfo = JSON.parse(localStorage.getItem("carInfo")) || {};
    },
    computed: {
      sortGroupCity() {
        let sortObj = {};
        for (let i = 65; i <= 90; i++) {
          sortObj[String.fromCharCode(i)] = this.allCityList.filter(
            item => item.spell.substring(0, 1) === String.fromCharCode(i)
          );
        }
        //删除无区域字母块
        for (let letter in sortObj) {
          if (sortObj[letter].length == 0) {
            delete sortObj[letter];
          }
        }
        return sortObj;
      },
      sortLetter() {
        let letters = [];
        for (let obj in this.sortGroupCity) {
          letters.push(obj);
        }
        letters.unshift("");
        letters.unshift("");
        return letters;
      }
    },
    created() {
    },
    mounted() {
      this.initGeo();
      this.initCityList();
    },
    methods: {
      async initCityList() {
        let res = await getShopCitys({
          data: {
            SourceID: 128,
            Hot: 0
          }
        });
        if (res.Code == 100) {
          let allCityList = [];
          for (let item of res.Data) {
            let obj = {
              city: item.ZDCityName,
              adCode: item.CityCode,
              spell: item.ZDCityBridge
            };
            this.allCityList.push(obj);
          }
        }
        // let hotRes = await getShopCitys({
        //   data: {
        //     SourceID: 0,
        //     Hot: 1
        //   }
        // });
        // if (hotRes.Code == 100) {
        //   let hotCityList = [];
        //   for (let item of res.Data) {
        //     let obj = {
        //       city: item.ZDCityName,
        //       adCode: item.CityCode,
        //       spell: item.ZDCityBridge
        //     };
        //     this.hotCityList.push(obj);
        //   }
        // }
        this.$nextTick(() => {
          this.getListHeight();
        });
      },
      setCity(item) {
        let cityInfo = item;
        localStorage.setItem("cityInfo", JSON.stringify(cityInfo));
        localStorage.removeItem("addressInfo");
        this.$router.replace({ path: '/addCar'});
      },
      getListHeight() {
        const listContainer = this.$refs.menuCityList;
        const listArr = Array.from(listContainer.children[0].children);
        listArr.forEach((item, index) => {
          this.cityListTop[index] = item.offsetTop;
        });
        this.cityListTop.unshift(2);
        this.cityListTop.unshift(1);
        console.log(this.cityListTop);
        this.listenScroll(listContainer);
      },
      listenScroll(element) {
        this.cityScroll = new BScroll(element, {
          probeType: 3,
          deceleration: 0.001,
          bounce: false,
          swipeTime: 3e3,
          click: true
        });
        this.cityScroll.on("scrollEnd", pos => {
          if (!element) { return; }
          this.cityListTop.forEach((item, index) => {
            if ( Math.abs(Math.round(pos.y)) >= item ) {
              console.log(Math.abs(Math.round(pos.y)));
              this.cityIndex = index;
            }
          });
        });
      },
      chooseLetter(i) {
        let index = i*1;
        this.cityIndex = index;
        this.cityIndexChange = false;
        this.cityScroll.scrollTo(0, -this.cityListTop[index], 400);
        this.cityScroll.on("scrollEnd", ()=>{
          this.cityIndexChange = true;
        });
      }
    }
  };
</script>
<style lang="scss" scoped type="text/scss">
  .home_container {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 110px;
    bottom: 0;
    right: 0;
    left: 0;
    background: #fff;
  }

  .home_detail_header {
    overflow: hidden;
    position: relative;
    z-index: 50;

    .description_header {
      position: relative;
      width: 100%;
      overflow: hidden;

      .wrap_description {
        display: flex;

        .description_content {
          flex: 1;

          .current {
            padding: 20px;
            font-size: 26px;

            > p {
              font-size: 26px;
              color: #000;
              display: inline-block;
              width: 30%;
              text-align: center;
              padding: 10px 0;
              background-color: #fff;
              border: 1px solid #eee; /*no*/
              border-radius: 5px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .lettersNav {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 240;
    background-color: #fff;

    .lettersList {
      li {
        width: 50px;
        height: 46px;
        line-height: 46px;
        text-align: center;
      }

      .select {
        background-color: #e57f01;
        color: #fff;
      }
    }
  }

  .city_tip,
  .city_title {
    display: flex;
    width: auto;
    height: 70px;
    line-height: 70px;
    font-size: 26px;
    color: #999;
    background-color: #f2f5f5;
    padding-left: 20px;

    span {
      color: #515151;
    }
  }

  .citylist {
    flex: 1;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    li {
      font-size: 26px;
      color: #000;
      margin-right: 10px;
      margin-bottom: 10px;
      display: inline-block;
      width: 30%;
      text-align: center;
      padding: 10px 0;
      background-color: #fff;
      border: 1px solid #eee; /*no*/
      border-radius: 5px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .letter_container {
    display: flex;
    flex: 1;
    border-bottom: 6px solid #fff;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .menu_container {
      display: flex;
      flex: 1;
      overflow-y: hidden;
      position: relative;

      .menu_center {
        flex: 1;

        .content {
          padding-bottom: 500px;
        }

        .ellipsis {
          font-size: 26px;
          color: #000;
          padding: 24px 20px;
          border-bottom: 1px solid #eee; /*no*/
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/car/cityList.vue